var _circle, _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSalesintelLogo = function SvgSalesintelLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.085,
    cy: 58.085,
    r: 58.085,
    fill: "#1F2533"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.3301,
    y: 27.9854,
    width: 20.8578,
    height: 20.8578,
    fill: "#FF5C0A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0849 -2.94891e-05C26.0053 -2.94891e-05 0 26.0083 0 58.0879C0 72.17 5.01073 85.0797 13.348 95.1379L48.7713 59.7147H31.5073V48.8418H67.3316V28.9989H87.178V48.8418H67.3316V84.6656H56.4587V67.4051L21.0354 102.825C31.0932 111.163 44.0034 116.173 58.0849 116.173C90.1681 116.173 116.173 90.168 116.173 58.0879C116.173 26.0083 90.1681 -2.94891e-05 58.0849 -2.94891e-05Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalesintelLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salesintelLogo.109e3ec8.svg";
export { ForwardRef as ReactComponent };